export const handleFileDownload = (
  file: File | null | undefined,
  url?: string,
) => {
  if (file) {
    const fileUrl = url ? url : URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    !url && URL.revokeObjectURL(fileUrl);
  }
};
